import React from 'react';
import { motion } from 'framer-motion';
export function Newsletter() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8
  }} className="py-24 px-6 bg-white" data-id="element-309">
      <div className="max-w-3xl mx-auto text-center" data-id="element-310">
        <h2 className="text-xl sm:text-2xl md:text-4xl font-display font-bold mb-6 tracking-[0.1em] md:tracking-[0.25em] uppercase" data-id="element-311">
          JOIN THE Djily Creations Culture
        </h2>
        <p className="text-sm md:text-base font-medium text-black/80 mb-4 tracking-widest leading-relaxed uppercase" data-id="element-312">
          Be the FIRST to learn about our new arrivals, in-store events and our
          'behind-the-scenes' projects.
        </p>
        <p className="text-sm md:text-base font-display font-bold text-black mb-10 tracking-[0.2em] uppercase" data-id="element-313">
          Sign-up now for our emails and get 10% OFF in-store.
        </p>

        <form className="flex flex-col md:flex-row gap-0 max-w-xl mx-auto group" data-id="element-314">
          <div className="relative flex-grow" data-id="element-315">
            <input type="email" placeholder="EMAIL ADDRESS" className="w-full bg-transparent border-b border-black/20 py-4 text-sm font-display font-bold tracking-[0.3em] focus:outline-none focus:border-black transition-colors placeholder:text-black/30" data-id="element-316" />
            <div className="absolute bottom-0 left-0 w-0 h-[1px] bg-black transition-all duration-500 group-focus-within:w-full" data-id="element-317" />
          </div>
          <button className="bg-black text-white px-12 py-4 text-[10px] font-display uppercase tracking-[0.3em] hover:bg-black/90 transition-all duration-300 mt-4 md:mt-0 md:ml-8" data-id="element-318">
            Subscribe
          </button>
        </form>
      </div>
    </motion.section>;
}